import { WidgetAction } from 'models/WidgetModel';
import './SwitchLineChartTable.scss';
import { appAssets } from 'constants/assets';
import { useWidgetContext } from 'contexts/WidgetProvider';

const SwitchLineChartTable = () => {
  const { showLineChart, setState } = useWidgetContext();

  const LineChartIcon = appAssets.icons.LINE_CHART;
  const TableIcon = appAssets.icons.TABLE;

  const handleTableClick = () => {
    setState({ action: WidgetAction.SWITCH_LINECHART_TABLE, showLineChart: false });
  };

  const handleChartClick = () => {
    setState({ action: WidgetAction.SWITCH_LINECHART_TABLE, showLineChart: true });
  };

  return (
    <div className="switchAction">
      <span className={!showLineChart ? 'active' : ''} onClick={handleTableClick}>
        <TableIcon className="icon" /> Table
      </span>{' '}
      <span className={showLineChart ? 'active' : ''} onClick={handleChartClick}>
        <LineChartIcon className="icon" /> Line
      </span>
    </div>
  );
};

export default SwitchLineChartTable;
